/* eslint-disable prettier/prettier */
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<Path d="M9 20h6V9H9v11zM4 4v1.5h16V4H4z" />
	</SVG>
);
/* eslint-enable */
